export default __webpack_public_path__ + "static/media/anweshgangula.68dd8893.jpeg";